//
//
//
//
//
//
//
//
//

import topBar from '@/components/topBar.vue';
import bottomBar from '~/components/bottomBar.vue';
import robot from '@/components/robot.vue'
import { isElectron } from '@/utils/constants';
import { user_api } from '@/api/api/user';

export default {
  components: {
    topBar,
    bottomBar,
    robot
  },
  data() {
    return {
      isClient: false,
      listMode: { community: false, website: false, plugin: false, download: false, personal: false, logout: true },
    };
  },
  async mounted() {
    this.isClient = isElectron();
    const top = this.$refs.topbar.$el.clientHeight;
    this.$store.commit('app/setTopbar', top);

    const res = await this.$axios.$post(user_api.switcher, { fname: 'web.resourcePublish' })
    this.listMode.personal = res.data['web.resourcePublish'];

    if (this.isClient) {
      this.listMode.logout = false;
    }
  },
  errorCaptured(err, vm, info) {
    if (info === 'render') {
      console.log('这是一个组件渲染的错误');
    } else {
      console.log('这是一个事件处理的错误');
    }
    console.log('[errorCaptured 错误处理]: ', err);
    // 阻止错误继续向外传播
    return false;
  },
  computed: {
    user_id() {
      return this.$store.state?.user?.userInfo?.id;
    },
    showFooter() {
      const routeName = this.$route.name;
      const showNames = ['index', 'plugin', 'activity', 'activity-detail',  'tag-tag_name', 'search'];
      return showNames.includes(routeName);
    },
  },
};
